import React from 'react';

function Services() {
  return (
    <section className="services">
      <div className="hero services-hero">
        <div className="hero-overlay">
          <h1>Our Services</h1>
          <p>Unmatched solutions for your aviation spare parts needs.</p>
        </div>
      </div>
      <main className="content">
        <div className="services-container">
          <div className="service-card">
            <div className="card-icon">
              <img src="https://img.icons8.com/ios-filled/50/1e3a8a/engine.png" alt="Parts Supply" />
            </div>
            <h2>Parts Supply</h2>
            <p>
              Access a vast inventory of precision-engineered aero spare parts, from engines to avionics, delivered worldwide.
            </p>
          </div>
          <div className="service-card">
            <div className="card-icon">
              <img src="https://img.icons8.com/ios-filled/50/1e3a8a/wrench.png" alt="Maintenance" />
            </div>
            <h2>Maintenance Support</h2>
            <p>
              Expert repair and overhaul services to keep your fleet airborne with minimal downtime.
            </p>
          </div>
          <div className="service-card">
            <div className="card-icon">
              <img src="https://img.icons8.com/ios-filled/50/1e3a8a/consultation.png" alt="Consulting" />
            </div>
            <h2>Parts Consulting</h2>
            <p>
              Tailored advice to optimize your spare parts procurement and inventory management.
            </p>
          </div>
        </div>
        {/* Moved CTA outside services-container
        <div className="cta-section">
          <h3>Need Spare Parts Now?</h3>
          <a href="/contact" className="cta-btn">Request a Quote</a>
        </div> */}
      </main>
    </section>
  );
}

export default Services;